module.exports = __webpack_public_path__ + "static/media/career-planning.190d25e9.mp4";